export default __webpack_public_path__ + "906b268174092039c4dcac7937cd69ff.svg";